import React, { useState, useEffect } from "react";
import "react-toastify/dist/ReactToastify.css";
import VehicleFilter from "./FilterVehicle";
import {
  downloadExcel,
  getWritePermission,
  downloadQRCodeImage,
  generateQRCodeSVG,
  handleDownloadQRCode,
} from "./utils/helpers";
import ModalComponent from "../../Common/popup_modal/ModalComponent";
import AddVehicleForm from "./AddVehicleForm";
import { useVehicleStore } from "./store/useVehicleStore";
import isGHMC from "../../Common/helper/helpar";
import Tooltip from "@mui/material/Tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import QRCode from "react-qr-code";
import Modal from "react-bootstrap/Modal";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { waveform } from "ldrs";
import "./VehicleStyles.css";

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Pagination,
  CircularProgress,
  TableContainer,
  Checkbox,
  Stack,
} from "@mui/material";
import { useFilterStore } from "./store/useFilterStore";
import { useDropdownStore } from "./store/useDropdownStore";
import { all } from "axios";

const Vehicle = () => {
  const canWrite = getWritePermission();
  const [PopupModal, setPopupModal] = useState(false);
  const [editVehicleData, setEditVehicleData] = useState(null);
  const [qrCodeModal, setQrCodeModal] = useState(false);
  const [page, setPage] = useState(1);
  const pageSize = 100;
  const [isExportExcelDownloadLoading, setIsExportExcelDownload] =
    useState(false);
  const [isExportQRDownloadLoading, setIsExportQRDownloadLoading] =
    useState(false);
  const [selectedQRs, setSelectedQRs] = useState([]);
  const [isQrImageDownloading, setIsQrImageDownloading] = useState(false);
  const [downloadProgress, setDownloadProgress] = useState(0);
  const [downloadStatus, setDownloadStatus] = useState("");

  waveform.register();

  const handleClose = () => {
    setPopupModal(false);
    setEditVehicleData(null);
    resetFileInputs();
  };

  /* ------- importing modules from the stores ------ */
  const {
    vehicleDetails,
    fetchVehicleDetails,
    allVehicles,
    fetchAllVehicles,
    isFetchVehicleDetailsLoading,
    isFetchAllVehiclesLoading,
    error,
    fetchVehicleDetailsError,
  } = useVehicleStore();
  const {
    filter,
    zones,
    circles,
    collectionTypes,
    vehicleTypes,
    ownerTypes,
    fetchFilterZones,
    fetchFilterCircles,
    fetchFilterCollectionTypes,
    fetchFilterVehicleTypes,
    fetchFilterOwnerTypes,
    setFilterField,
    resetFilters,
    loading,
  } = useFilterStore();
  const { resetFileInputs } = useDropdownStore();

  /* ------- importing modules from the stores ------ */

  /* ------ filter functions ------- */
  const handleFilterChange = (field, value) => {
    setFilterField(field, value);

    if (field === "zoneId") {
      setFilterField("circleId", "");
      if (value) {
        fetchFilterCircles(value);
      } else {
        fetchFilterCircles([]);
      }
    } else if (field === "collectionTypeId") {
      setFilterField("vehicleTypeId", "");
      fetchFilterVehicleTypes(value);
    }
  };

  const handleSearch = () => {
    setPage(1);
    fetchVehicleDetails(page, pageSize, filter);
  };

  const handleReset = () => {
    resetFilters();
    setPage(1);
    fetchVehicleDetails(page, pageSize, {});
  };
  /* ------ filter functions ------- */

  /* ------ export excel -------- */

  const handleExcelExport = async () => {
    try {
      setIsExportExcelDownload(true);
      // Fetch all vehicles for Excel export (using a large page size to get all data)
      const allVehiclesResponse = await fetchAllVehicles(1, 5000, filter);
      if (allVehiclesResponse && allVehiclesResponse.data) {
        downloadExcel(allVehiclesResponse.data);
      } else {
        console.warn("No vehicle data available for export.");
      }
    } catch (error) {
      console.error("Error fetching vehicle data for export: ", error);
    } finally {
      setIsExportExcelDownload(false);
    }
  };
  /* ------ export excel -------- */
  /* ------ export QR codes -------- */
  const handleSelectQR = (uuid) => {
    setSelectedQRs((prev) =>
      prev.includes(uuid) ? prev.filter((id) => id !== uuid) : [...prev, uuid]
    );
  };
  const handleDownloadSelectedQRCodes = async () => {
    try {
      setIsExportQRDownloadLoading(true);
      setDownloadProgress(0);
      setDownloadStatus("Preparing download...");

      let vehiclesToDownload;
      if (selectedQRs.length > 0) {
        // Download only selected QR codes
        vehiclesToDownload = vehicleDetails.data.filter((vehicle) =>
          selectedQRs.includes(vehicle.vehicleUuid)
        );
      } else {
        // Fetch all vehicles if none selected
        const allVehiclesResponse = await fetchAllVehicles(1, 5000, filter);
        vehiclesToDownload = allVehiclesResponse
          ? allVehiclesResponse.data
          : [];
      }

      if (vehiclesToDownload.length > 0) {
        setDownloadStatus(`Processing ${vehiclesToDownload.length} vehicles...`);
        
        await handleDownloadQRCode(vehiclesToDownload, (progress, processed, total) => {
          setDownloadProgress(progress);
          setDownloadStatus(`Processing ${processed}/${total} vehicles (${progress}%)`);
        });
        
        setDownloadStatus("Download completed!");
      } else {
        console.warn("No vehicle data available for export.");
        setDownloadStatus("No vehicles to download");
      }
    } catch (error) {
      console.error("Error fetching vehicle data for export: ", error);
      setDownloadStatus("Download failed");
    } finally {
      setIsExportQRDownloadLoading(false);
      // Reset progress after a delay
      setTimeout(() => {
        setDownloadProgress(0);
        setDownloadStatus("");
      }, 2000);
    }
  };
  /* ------ export QR codes -------- */

  const handlePageChange = (event, value) => {
    setPage(value);
    fetchVehicleDetails(value, pageSize, filter);
  };

  useEffect(() => {
    fetchFilterZones();
    fetchFilterCollectionTypes();
    fetchFilterOwnerTypes();
    fetchVehicleDetails(page, pageSize, filter);
    fetchAllVehicles(page, 5000, filter);
  }, []);

  const isProd = isGHMC();
  const vehicles = vehicleDetails?.data || [];

  const evenStyle = {
    border: "1px solid rgb(255, 255, 255)",
    paddingLeft: "25px",
    textAlign: "justify",
    backgroundColor: "rgb(248, 204, 205)",
  };

  const oddStyle = {
    border: "1px solid rgb(255, 255, 255)",
    textAlign: "justify",
    backgroundColor: "rgb(255, 237, 238)",
    color: "inherit",
  };
  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="page-header">
              <div className="page-header-filter">
                <div className="row">
                  <div className="col-md-12">
                    <div className="vehicle-button mb-3 mt-0">
                      {/* {canWrite === true ? ( */}
                        <button
                          className="button-container"
                          onClick={() => setPopupModal(true)}
                        >
                          <i className="fa-solid fa-plus me-1 icon-container"></i>
                          Add Vehicle
                        </button>
                      {/* ) : (
                        ""
                      )} */}
                      <button
                        className="btn btn-excel"
                        onClick={handleExcelExport}
                        disabled={
                          isExportExcelDownloadLoading ||
                          isFetchVehicleDetailsLoading
                        }
                      >
                        {isExportExcelDownloadLoading ? (
                          <l-waveform
                            size="20"
                            stroke="3.5"
                            speed="1"
                            color="black"
                          ></l-waveform>
                        ) : (
                          <>
                            <i className="fa-solid fa-file-excel me-1 icon-container"></i>
                            Excel
                          </>
                        )}
                      </button>

                      <button
                        className="btn btn-excel"
                        onClick={() => handleDownloadSelectedQRCodes()}
                        disabled={isExportQRDownloadLoading}
                      >
                        {isExportQRDownloadLoading ? (
                          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <l-waveform
                              size="20"
                              stroke="3.5"
                              speed="1"
                              color="black"
                            ></l-waveform>
                            <span style={{ fontSize: "12px" }}>
                              {downloadProgress > 0 ? `${downloadProgress}%` : "Processing..."}
                            </span>
                          </div>
                        ) : (
                          <>
                            <i className="fa-regular fa-file-pdf me-1 icon-container"></i>
                            Download QR
                          </>
                        )}
                      </button>
                      
                      {/* Progress indicator */}
                      {isExportQRDownloadLoading && downloadProgress > 0 && (
                        <div style={{ 
                          marginTop: "8px", 
                          fontSize: "12px", 
                          color: "#666",
                          textAlign: "center"
                        }}>
                          {downloadStatus}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="page-header-left">
                      <VehicleFilter
                        filter={filter}
                        handleFilterChange={handleFilterChange}
                        handleSearch={handleSearch}
                        handleReset={handleReset}
                        zones={zones}
                        circles={circles}
                        collectionTypes={collectionTypes}
                        vehicleTypes={vehicleTypes}
                        ownerTypes={ownerTypes}
                        loading={isFetchVehicleDetailsLoading}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card mt-3">
              <div className="card-body">
                <div className="top-header">
                  <span>Vehicle Details</span>
                </div>

                <div>
                  <Paper sx={{ width: "100%", overflow: "hidden" }}>
                    {isFetchVehicleDetailsLoading ? (
                      <div style={{ textAlign: "center", padding: "20px" }}>
                        <CircularProgress />
                      </div>
                    ) : fetchVehicleDetailsError ? (
                      <div style={{ color: "red", textAlign: "center" }}>
                        {fetchVehicleDetailsError}
                      </div>
                    ) : vehicles.length > 0 ? (
                      <>
                        {/* Add TableContainer for responsive behavior */}
                        <TableContainer
                          sx={{ maxHeight: "70vh", fontSize: "13px" }}
                        >
                          <Table
                            stickyHeader
                            className="custom-table"
                            aria-label="vehicle details table"
                            sx={{ fontSize: "13px" }}
                          >
                            <TableHead>
                              <TableRow>
                                <TableCell
                                  className={`btn  ${isProd ? "ghmc-table-col" : "swm-table-col"}`}
                                >
                                  S.No
                                </TableCell>
                                <TableCell
                                  className={`btn  ${isProd ? "ghmc-table-col" : "swm-table-col"}`}

                                >
                                  Vehicle Number
                                </TableCell>
                                <TableCell
                                  className={`btn  ${isProd ? "ghmc-table-col" : "swm-table-col"}`}

                                  title="Vehicle Unique Identification"
                                >
                                  Vehicle UID
                                </TableCell>
                                <TableCell
                                  className={`btn  ${isProd ? "ghmc-table-col" : "swm-table-col"}`}

                                >
                                  Vehicle Type
                                </TableCell>
                                <TableCell
                                  className={`btn  ${isProd ? "ghmc-table-col" : "swm-table-col"}`}

                                >
                                  Vehicle Capacity
                                </TableCell>
                                <TableCell
                                  className={`btn  ${isProd ? "ghmc-table-col" : "swm-table-col"}`}

                                >
                                  Zone
                                </TableCell>
                                {/* <TableCell
                                className={`btn  ${isProd ? "ghmc-table-col" : "swm-table-col"}`}
                                 
                                >
                                  Circle
                                </TableCell> */}
                                <TableCell
                                  className={`btn  ${isProd ? "ghmc-table-col" : "swm-table-col"}`}

                                >
                                  Ward
                                </TableCell>
                                <TableCell
                                  className={`btn  ${isProd ? "ghmc-table-col" : "swm-table-col"}`}

                                >
                                  Collection Type
                                </TableCell>
                                <TableCell
                                  className={`btn  ${isProd ? "ghmc-table-col" : "swm-table-col"}`}

                                >
                                  Owner Type
                                </TableCell>
                                <TableCell
                                  className={`btn  ${isProd ? "ghmc-table-col" : "swm-table-col"}`}

                                >
                                  Driver Name
                                </TableCell>
                                <TableCell
                                  className={`btn  ${isProd ? "ghmc-table-col" : "swm-table-col"}`}

                                >
                                  Driver Number
                                </TableCell>
                                <TableCell
                                  className={`btn  ${isProd ? "ghmc-table-col" : "swm-table-col"}`}

                                >
                                  Primary Deployment<br />Incharge Name
                                </TableCell>
                                <TableCell
                                  className={`btn  ${isProd ? "ghmc-table-col" : "swm-table-col"}`}

                                >
                                  Primary Deployment<br />Incharge Number
                                </TableCell>
                                <TableCell
                                  className={`btn  ${isProd ? "ghmc-table-col" : "swm-table-col"}`}

                                >
                                  Transferstation
                                </TableCell>
                                <TableCell
                                  className={`btn  ${isProd ? "ghmc-table-col" : "swm-table-col"}`}

                                >
                                  <div className="d-flex align-items-center gap-2">
                                    {/* <Checkbox
                                    checked={selectAll}
                                    onChange={handleSelectAll}
                                  /> */}

                                    QR Code
                                  </div>
                                </TableCell>
                                <TableCell
                                  className={`btn  ${isProd ? "ghmc-table-col" : "swm-table-col"}`}

                                >
                                  Status
                                </TableCell>
                                <TableCell
                                  className={`btn  ${isProd ? "ghmc-table-col" : "swm-table-col"}`}

                                >
                                  Actions
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {vehicleDetails?.data.map((vehicle, index) => (
                                <TableRow
                                  key={vehicle.vehicleId}
                                  style={{
                                    backgroundColor:
                                      isProd
                                        ? index % 2 === 0
                                          ? "rgb(143, 201, 255)"
                                          : "rgb(174 216 255)"
                                        : index % 2 === 0
                                          ? "#F8CCCD"
                                          : "rgb(255 237 238)",

                                  }}
                                >
                                  <TableCell style={{ textAlign: "center", border: "1px solid #fff", }}>
                                    {index + 1 + (page - 1) * pageSize}
                                  </TableCell>
                                  <TableCell style={{ textAlign: "center", border: "1px solid #fff", }}>
                                    {vehicle.vehicleNumber || "N/A"}
                                  </TableCell>
                                  <TableCell style={{ textAlign: "center", border: "1px solid #fff", }}>
                                    {vehicle.vehicleUuid || "N/A"}
                                  </TableCell>
                                  <TableCell style={{ textAlign: "center", border: "1px solid #fff", }}>
                                    {vehicle.vehicleTypeName || "N/A"}
                                  </TableCell>
                                  <TableCell style={{ textAlign: "center", border: "1px solid #fff", }}>
                                    {vehicle.vehicleCapacityName || "N/A"}
                                  </TableCell>
                                  <TableCell style={{ textAlign: "center", border: "1px solid #fff", }}>
                                    {vehicle.zoneName || "N/A"}
                                  </TableCell>
                                  <TableCell style={{ textAlign: "center", border: "1px solid #fff", }}>
                                    {vehicle.circleName || "N/A"}
                                  </TableCell>
                                  {/* <TableCell style={{ textAlign: "center", border: "1px solid #fff", }}>
                                    {vehicle.wardName || "N/A"}
                                  </TableCell> */}
                                  <TableCell style={{ textAlign: "center", border: "1px solid #fff", }}>
                                    {vehicle.collectionTypeName || "N/A"}
                                  </TableCell>
                                  <TableCell style={{ textAlign: "center", border: "1px solid #fff", }}>
                                    {vehicle.ownerTypeName || "N/A"}
                                  </TableCell>
                                  <TableCell style={{ textAlign: "center", border: "1px solid #fff", }}>
                                    {vehicle.driverName || "N/A"}
                                  </TableCell>
                                  <TableCell style={{ textAlign: "center", border: "1px solid #fff", }}>
                                    {vehicle.driverNumber || "N/A"}
                                  </TableCell>
                                  <TableCell style={{ textAlign: "center", border: "1px solid #fff", }}>
                                    {vehicle.secondaryDeploymentInchargeName || "N/A"}
                                  </TableCell>
                                  <TableCell style={{ textAlign: "center", border: "1px solid #fff", }}>
                                    {vehicle.secondaryDeploymentInchargeNumber || "N/A"}
                                  </TableCell>
                                  <TableCell style={{ textAlign: "center", border: "1px solid #fff", }}>
                                    {vehicle.transferStationName || "N/A"}
                                  </TableCell>
                                  <TableCell style={{ textAlign: "center", border: "1px solid #fff", }}>
                                    <div className="d-flex gap-2 align-items-center">
                                      {/* <Checkbox
                                      checked={selectedQRs.includes(
                                        vehicle.vehicleUuid
                                      )}
                                      onChange={() =>
                                        handleSelectQR(vehicle.vehicleUuid)
                                      }
                                    /> */}
                                      <input
                                        type="checkbox"
                                        checked={selectedQRs.includes(
                                          vehicle.vehicleUuid
                                        )}
                                        onChange={() =>
                                          handleSelectQR(vehicle.vehicleUuid)
                                        }
                                      />
                                      <span
                                        className=""
                                        style={{
                                          cursor: "pointer",
                                          textDecoration: "underline",
                                          color: "blue",
                                        }}
                                        onClick={() => {
                                          setQrCodeModal(true);
                                          setEditVehicleData(vehicle);
                                        }}
                                      >
                                        View
                                      </span>
                                    </div>
                                  </TableCell>
                                  <TableCell style={{ textAlign: "center", border: "1px solid #fff", }}>
                                    {vehicle.isActive ? "Active" : "InActive"}
                                  </TableCell>
                                  <TableCell style={{ textAlign: "center", border: "1px solid #fff", }}>
                                    <Tooltip title="Edit" placement="top">
                                      <button
                                        className={`${index % 2 === 0
                                            ? "bg-F8CCCD"
                                            : "bg-ddefff"
                                          } ${isProd ? "edit-ghmc" : "edit-swm"}`}
                                        onClick={() => {
                                          setPopupModal(true);
                                          setEditVehicleData(vehicle);
                                        }}
                                      >
                                        <FontAwesomeIcon icon={faEdit} />
                                      </button>
                                    </Tooltip>
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>

                        {/* Pagination */}
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            padding: "20px 0",
                          }}
                        >
                          {/* <Pagination
                            count={Math.ceil(
                              vehicleDetails?.totalCount / pageSize
                            )} // Assuming `vehicleDetails.total` gives the total number of vehicles
                            page={page}
                            onChange={handlePageChange}
                            color="primary"
                          /> */}
                          <Stack spacing={2}>
                            <Pagination
                              count={Math.ceil(
                                vehicleDetails?.totalCount / pageSize
                              )}
                              page={page}
                              onChange={handlePageChange}
                              sx={{
                                "&.Mui-selected": {
                                  backgroundColor: "rgb(236, 17, 23)",
                                  color: "#fff",
                                },
                                "&:hover": {
                                  // backgroundColor: "rgba(236, 17, 23, 0.8)", // Hover background color
                                },
                                borderColor: "rgba(236, 17, 23)",
                                color: "rgb(236, 17, 23)",
                              }}
                              variant="outlined"
                              shape="rounded"
                            />
                          </Stack>
                        </div>
                      </>
                    ) : (
                      <p>No vehicles available</p>
                    )}
                  </Paper>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* modals */}
      <ModalComponent
        title={editVehicleData ? "Edit Vehicle" : "Add Vehicle"}
        show={PopupModal}
        onHide={handleClose}
        size="lg"
        handleClose={handleClose}
      >
        {/* Dynamic content inside the modal body */}
        <div>
          <AddVehicleForm
            editVehicleData={editVehicleData}
            setEditVehicleData={setEditVehicleData}
            handleSearch={handleSearch}
            handleClose={handleClose}
          />
        </div>
      </ModalComponent>
      {/* modals */}
      <Modal show={qrCodeModal} onHide={() => {
        setQrCodeModal(false);
        setEditVehicleData(null);
      }}>
        <Modal.Header closeButton>
          <Modal.Title>QR Code</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {/* Render vehicle details above the QR code */}

          {/* Render the QR code */}
          {editVehicleData?.vehicleUuid && (
            <div
              id="qrCode"
              style={{ margin: "10px 0" }}
              dangerouslySetInnerHTML={{
                __html: generateQRCodeSVG(editVehicleData.vehicleUuid),
              }}
            />
          )}
          {editVehicleData?.vehicleUuid && (
            <div style={{ textAlign: "center", marginBottom: "10px", width: "100%" }}>
              <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", maxWidth: "300px", margin: "0 auto" }}>
                {[
                  { label: "VEH. REG. NO", value: editVehicleData.vehicleNumber || "-" },
                  { label: "ZONE", value: editVehicleData.zoneName || "-" },
                  { label: "WARD", value: editVehicleData.circleName || "-" },
                  ...(editVehicleData.collectionTypeId != 1
                    ? [
                      { label: "VEHICLE CAPACITY", value: editVehicleData.vehicleCapacityName || "-" },
                      { label: "UID", value: editVehicleData.vehicleUuid || "-" },
                    ]
                    : []),
                ].map((item, index) => (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                      marginBottom: "7px",
                      fontSize: "14px",
                    }}
                  >
                    <span style={{ fontWeight: "bold", textAlign: "left", width: "150px" }}>
                      {item.label}:
                    </span>
                    <span style={{ textAlign: "left", flex: 1 }}>
                      {item.value}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          )}
          <h4
            // className="mt-4"
            style={{ fontWeight: "500", color: "blue", cursor: "pointer" }}
            onClick={() => {
              downloadQRCodeImage(editVehicleData);
            }}
          >
            Download
          </h4>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Vehicle;
